<template>
    <div class="upgrade" v-bind:class="{ open: internalOpen, selected: hasQty }">
        <div class="upgrade__header">
            <div class="upgrade__icon u-d-none u-d-inline-block-md" style="width: 3rem; height: 3rem; background-color: rgb(227,201,133);"></div>
            <div class="upgrade__meta">
                <h3 class="upgrade__name">
                    {{addon.name}}
                    <img src="../assets/images/arrow.svg" class="icon-arrow" alt="arrow">
                </h3>
                <div class="upgrade__price">
                    <span>{{getCurrencyString(addon.currency_amount)}}<sup>.00</sup></span>
                    <span class="u-d-none u-d-inline-block-sm"></span>
                </div>
            </div>

            <div class="upgrade__quantity">
                <button class="upgrade__quantity__control upgrade__quantity__control--decrement control" aria-label="Decrement" @click="decrement" :disabled="internalTicketTotal == 0">
                    <span class="control__text"><span class="u-sr">Decrement</span>-</span>
                </button>
                <div class="upgrade__quantity__control upgrade__quantity__control--input">{{internalTicketTotal}}</div>
                <!-- <input class="upgrade__quantity__control upgrade__quantity__control--input" type="number" min="0" max="40" value="0"> -->
                <button class="upgrade__quantity__control upgrade__quantity__control--increment control" aria-label="Increment" @click="increment">
                    <span class="control__text"><span class="u-sr">Increment</span>+</span>
                </button>
            </div>
        </div>

        <p class="upgrade__footer">
            All suites come with complimentary champagne and canapés, plus you'll have access to a private bar to top up your glasses. Our suites are perfect for Christmas or private parties. Split the cost, avoid the crowds and enjoy your own space. Suite prices do not include the cost of ticket.
        </p>
    </div>
</template>

<script>
export default {
    name: 'UpgradeControl',
    props: ['open', 'selected', 'qty', 'addon', 'sessionTime'],
    computed: {
        internalOpen() {
            if(this.open) {
                return this.open;
            } else {
                return false;
            }
        },
        internalSelected() {
            if(this.selected) {
                return this.selected;
            } else {
                return false;
            }
        },
        hasQty() {
            return this.internalTicketTotal > 0;
        },
    },
    methods: {
        getCurrencyString: function(value) {
            return '$' + parseFloat(value).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        },
        increment: function(event) {
            this.internalTicketTotal += 1;
            this.$emit('update:qty', this.internalTicketTotal);
        },

        decrement: function(event) {
            if(this.internalTicketTotal > 0) {
                this.internalTicketTotal -= 1;
                this.$emit('update:qty', this.internalTicketTotal);
            }
        }
    },
    data: function() {
        return {
            internalTicketTotal: this.qty
        }
    },
}
</script>

<style>

</style>
